// Generated by purs version 0.15.15
import * as Class_MonadLog from "../Class.MonadLog/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Array_NonEmpty from "../Data.Array.NonEmpty/index.js";
import * as Data_Array_NonEmpty_Internal from "../Data.Array.NonEmpty.Internal/index.js";
import * as Data_BigInt from "../Data.BigInt/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_FunctorWithIndex from "../Data.FunctorWithIndex/index.js";
import * as Data_HashMap from "../Data.HashMap/index.js";
import * as Data_Hashable from "../Data.Hashable/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Semigroup_Foldable from "../Data.Semigroup.Foldable/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Time_Duration from "../Data.Time.Duration/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Fusion_Data_Bytes from "../Fusion.Data.Bytes/index.js";
import * as Fusion_Data_Duration from "../Fusion.Data.Duration/index.js";
import * as Fusion_Data_Speed from "../Fusion.Data.Speed/index.js";
import * as Fusion_Data_Timestamp from "../Fusion.Data.Timestamp/index.js";
import * as Fusion_Impl_AppM from "../Fusion.Impl.AppM/index.js";
import * as Fusion_Statistics from "../Fusion.Statistics/index.js";
import * as Partial_Unsafe from "../Partial.Unsafe/index.js";
import * as Test_Spec from "../Test.Spec/index.js";
import * as Test_Spec_Assertions from "../Test.Spec.Assertions/index.js";
import * as WE_Class_Time from "../WE.Class.Time/index.js";
var mapWithIndex = /* #__PURE__ */ Data_FunctorWithIndex.mapWithIndex(Data_FunctorWithIndex.functorWithIndexArray);
var length = /* #__PURE__ */ Data_Foldable.length(Data_Array_NonEmpty_Internal.foldableNonEmptyArray)(Data_Semiring.semiringInt);
var minimum = /* #__PURE__ */ Data_Semigroup_Foldable.minimum(Data_Ord.ordNumber)(Data_Array_NonEmpty_Internal.foldable1NonEmptyArray);
var maximum = /* #__PURE__ */ Data_Semigroup_Foldable.maximum(Data_Ord.ordNumber)(Data_Array_NonEmpty_Internal.foldable1NonEmptyArray);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var convertDuration = /* #__PURE__ */ Data_Time_Duration.convertDuration(Fusion_Data_Duration.durationDuration)(Data_Time_Duration.durationMilliseconds);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(Fusion_Data_Duration.monoidDuration);
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Maybe.bindMaybe);
var lessThan1 = /* #__PURE__ */ Data_Ord.lessThan(Fusion_Data_Timestamp.ordTimestamp);
var greaterThan = /* #__PURE__ */ Data_Ord.greaterThan(Fusion_Data_Timestamp.ordTimestamp);
var greaterThanOrEq = /* #__PURE__ */ Data_Ord.greaterThanOrEq(Fusion_Data_Timestamp.ordTimestamp);
var eq2 = /* #__PURE__ */ Data_Eq.eq(Fusion_Data_Timestamp.eqTimestamp);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Maybe.applicativeMaybe);
var map = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var maximum1 = /* #__PURE__ */ Data_Foldable.maximum(Fusion_Data_Timestamp.ordTimestamp)(Data_Foldable.foldableArray);
var minimum1 = /* #__PURE__ */ Data_Foldable.minimum(Fusion_Data_Timestamp.ordTimestamp)(Data_Foldable.foldableArray);
var unfoldr = /* #__PURE__ */ Data_Unfoldable.unfoldr(Data_Unfoldable.unfoldableArray);
var mempty1 = /* #__PURE__ */ Data_Monoid.mempty(Fusion_Data_Speed.monoidSpeed);
var fold = /* #__PURE__ */ Data_Foldable.fold(Data_Foldable.foldableArray)(Fusion_Data_Speed.monoidSpeed);
var minimumBy = /* #__PURE__ */ Data_Semigroup_Foldable.minimumBy(Data_Array_NonEmpty_Internal.foldable1NonEmptyArray);
var compare = /* #__PURE__ */ Data_Ord.compare(Fusion_Data_Timestamp.ordTimestamp);
var foldl = /* #__PURE__ */ Data_Foldable.foldl(Data_Array_NonEmpty_Internal.foldableNonEmptyArray);
var insertWith = /* #__PURE__ */ Data_HashMap.insertWith(Data_Hashable.hashableInt);
var append1 = /* #__PURE__ */ Data_Semigroup.append(Fusion_Data_Bytes.semigroupBytes);
var maximum2 = /* #__PURE__ */ Data_Foldable.maximum(Data_Ord.ordInt)(Data_Foldable.foldableArray);
var lookup = /* #__PURE__ */ Data_HashMap.lookup(Data_Hashable.hashableInt);
var lessThanOrEq = /* #__PURE__ */ Data_Ord.lessThanOrEq(Fusion_Data_Duration.ordDuration);
var maximum3 = /* #__PURE__ */ Data_Foldable.maximum(Data_Ord.ordNumber)(Data_Foldable.foldableArray);
var greaterThan1 = /* #__PURE__ */ Data_Ord.greaterThan(Fusion_Data_Speed.ordSpeed);
var describe = /* #__PURE__ */ Test_Spec.describe(Data_Identity.monadIdentity);
var fromJust = /* #__PURE__ */ Data_Maybe.fromJust();
var discard1 = /* #__PURE__ */ discard(/* #__PURE__ */ Test_Spec.bindSpecT(Data_Identity.bindIdentity));
var it = /* #__PURE__ */ Test_Spec.it(Data_Identity.monadIdentity)(Test_Spec.exampleMUnit);
var shouldEqual = /* #__PURE__ */ Test_Spec_Assertions.shouldEqual(Effect_Aff.monadThrowAff);
var shouldEqual1 = /* #__PURE__ */ shouldEqual(Fusion_Data_Speed.showSpeed)(Fusion_Data_Speed.eqSpeed);
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var maxTimeIsSymbol = {
    reflectSymbol: function () {
        return "maxTime";
    }
};
var minTimeIsSymbol = {
    reflectSymbol: function () {
        return "minTime";
    }
};
var eqRec = /* #__PURE__ */ Data_Eq.eqRec();
var eqRowCons = /* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)();
var shouldEqual2 = /* #__PURE__ */ shouldEqual(/* #__PURE__ */ Data_Maybe.showMaybe(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(maxTimeIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(minTimeIsSymbol)(Fusion_Data_Timestamp.showTimestamp))(Fusion_Data_Timestamp.showTimestamp))))(/* #__PURE__ */ Data_Maybe.eqMaybe(/* #__PURE__ */ eqRec(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ eqRowCons(minTimeIsSymbol)(Fusion_Data_Timestamp.eqTimestamp))()(maxTimeIsSymbol)(Fusion_Data_Timestamp.eqTimestamp))));
var shouldEqual3 = /* #__PURE__ */ shouldEqual(/* #__PURE__ */ Data_Maybe.showMaybe(Fusion_Data_Speed.showSpeed))(/* #__PURE__ */ Data_Maybe.eqMaybe(Fusion_Data_Speed.eqSpeed));
var speedIsSymbol = {
    reflectSymbol: function () {
        return "speed";
    }
};
var timestampIsSymbol = {
    reflectSymbol: function () {
        return "timestamp";
    }
};
var showRecord1 = /* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(speedIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(timestampIsSymbol)(Fusion_Data_Timestamp.showTimestamp))(Fusion_Data_Speed.showSpeed));
var showArray = /* #__PURE__ */ Data_Show.showArray(showRecord1);
var eqRec1 = /* #__PURE__ */ eqRec(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ eqRowCons(timestampIsSymbol)(Fusion_Data_Timestamp.eqTimestamp))()(speedIsSymbol)(Fusion_Data_Speed.eqSpeed));
var eqArray = /* #__PURE__ */ Data_Eq.eqArray(eqRec1);
var shouldEqual4 = /* #__PURE__ */ shouldEqual(/* #__PURE__ */ Data_Maybe.showMaybe(showArray))(/* #__PURE__ */ Data_Maybe.eqMaybe(eqArray));
var discard2 = /* #__PURE__ */ discard(Effect_Aff.bindAff);
var shouldEqual5 = /* #__PURE__ */ shouldEqual(/* #__PURE__ */ Data_Maybe.showMaybe(showRecord1))(/* #__PURE__ */ Data_Maybe.eqMaybe(eqRec1));
var shouldEqual6 = /* #__PURE__ */ shouldEqual(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showInt))(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Eq.eqInt));
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Data_Maybe.functorMaybe);
var length1 = /* #__PURE__ */ Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt);
var shouldEqual7 = /* #__PURE__ */ shouldEqual(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ Data_Array_NonEmpty_Internal.showNonEmptyArray(Data_Show.showInt)))(/* #__PURE__ */ Data_Eq.eqArray(/* #__PURE__ */ Data_Array_NonEmpty_Internal.eqNonEmptyArray(Data_Eq.eqInt)));
var shouldEqual8 = /* #__PURE__ */ shouldEqual(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showNumber))(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Eq.eqNumber));
var append2 = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var shouldEqual9 = /* #__PURE__ */ shouldEqual(showArray)(eqArray);
var bind1 = /* #__PURE__ */ Control_Bind.bind(Effect_Aff.bindAff);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Fusion_Impl_AppM.applicativeAppM);
var pure2 = /* #__PURE__ */ Control_Applicative.pure(Effect_Aff.applicativeAff);
var windows = function (n) {
    return function (items) {
        return Data_Array.catMaybes(mapWithIndex(function (ix) {
            return function (v) {
                var win = Data_Array.slice(ix)(ix + n | 0)(items);
                var v1 = Data_Array_NonEmpty.fromArray(win);
                if (v1 instanceof Data_Maybe.Just && length(v1.value0) === n) {
                    return new Data_Maybe.Just(v1.value0);
                };
                return Data_Maybe.Nothing.value;
            };
        })(items));
    };
};
var stableAverage = function (win) {
    var $191 = Data_Maybe.isJust(Data_Array_NonEmpty.find(function (v) {
        return v === 0.0;
    })(win));
    if ($191) {
        return Data_Maybe.Nothing.value;
    };
    var vmin = minimum(win);
    var vmax = maximum(win);
    var $192 = vmax / vmin < 1.2;
    if ($192) {
        return new Data_Maybe.Just(Fusion_Statistics.average(win));
    };
    return Data_Maybe.Nothing.value;
};
var measureTime = function (dictMonadApp) {
    var Monad0 = (dictMonadApp.MonadWebsockets5()).Monad0();
    var Bind1 = Monad0.Bind1();
    var bind2 = Control_Bind.bind(Bind1);
    var MonadAppNE4 = dictMonadApp.MonadAppNE4();
    var now = WE_Class_Time.now(MonadAppNE4.MonadTime2());
    var discard3 = discard(Bind1);
    var log = Class_MonadLog.log(MonadAppNE4.MonadLog8());
    var pure3 = Control_Applicative.pure(Monad0.Applicative0());
    return function (message) {
        return function (actionBlock) {
            return bind2(now)(function (startTime) {
                return bind2(actionBlock(Data_Unit.unit))(function (result) {
                    return bind2(now)(function (endTime) {
                        return discard3(log(message + (" " + Fusion_Data_Duration.prettyPrint(Fusion_Data_Timestamp.diff(endTime)(startTime)))))(function () {
                            return pure3(result);
                        });
                    });
                });
            });
        };
    };
};
var measureTime1 = /* #__PURE__ */ measureTime(Fusion_Impl_AppM.monadAppFSErrorAppMFSErro);
var linearInterpolate = function (dataPoint1) {
    return function (dataPoint2) {
        return function (timestamp) {
            var durToMs = function (d) {
                return unwrap(convertDuration(d));
            };
            var tsToMs = function (ts) {
                return durToMs(Fusion_Data_Timestamp.diff(ts)(Fusion_Data_Timestamp.timeIntervalSince1970(mempty)));
            };
            var t3 = tsToMs(dataPoint2.timestamp);
            var t2 = tsToMs(timestamp);
            var t1 = tsToMs(dataPoint1.timestamp);
            var t2d = t2 - t1;
            var t3d = t3 - t1;
            var s3 = Fusion_Data_Speed.toBps(dataPoint2.speed);
            var s1 = Fusion_Data_Speed.toBps(dataPoint1.speed);
            var s3d = s3 - s1;
            var factor = (function () {
                var $193 = t3d === 0.0;
                if ($193) {
                    return 0.0;
                };
                return t2d / t3d;
            })();
            var s2d = factor * s3d;
            var s2 = s1 + s2d;
            return Fusion_Data_Speed.fromBps(s2);
        };
    };
};
var speedAtTime = function (coalesceInterval) {
    return function (interpolationTime) {
        return function (dataPoints) {
            return bind(Data_Array.head(dataPoints))(function (first) {
                return bind(Data_Array.last(dataPoints))(function (last) {
                    var $194 = lessThan1(interpolationTime)(first.timestamp);
                    if ($194) {
                        return Data_Maybe.Nothing.value;
                    };
                    var $195 = greaterThan(interpolationTime)(Fusion_Data_Timestamp.addDuration(last.timestamp)(coalesceInterval));
                    if ($195) {
                        return Data_Maybe.Nothing.value;
                    };
                    var $196 = greaterThan(interpolationTime)(last.timestamp) && lessThan1(interpolationTime)(Fusion_Data_Timestamp.addDuration(last.timestamp)(coalesceInterval));
                    if ($196) {
                        return new Data_Maybe.Just(last.speed);
                    };
                    return bind(Data_Array.findIndex(function (dp) {
                        return greaterThanOrEq(dp.timestamp)(interpolationTime);
                    })(dataPoints))(function (closestBehindIdx) {
                        return bind(Data_Array.index(dataPoints)(closestBehindIdx))(function (closestBehind) {
                            var $197 = eq2(closestBehind.timestamp)(interpolationTime);
                            if ($197) {
                                return pure(closestBehind.speed);
                            };
                            return bind(Data_Array.index(dataPoints)(closestBehindIdx - 1 | 0))(function (closestBefore) {
                                var interpolatedSpeed = linearInterpolate(closestBefore)(closestBehind)(interpolationTime);
                                return pure(interpolatedSpeed);
                            });
                        });
                    });
                });
            });
        };
    };
};
var getMinMax = function (streamIntermediates) {
    var getMaxPerStream = (function () {
        var $214 = map(function (v) {
            return v.timestamp;
        });
        return function ($215) {
            return $214(Data_Array.last($215));
        };
    })();
    var getMinPerStream = (function () {
        var $216 = map(function (v) {
            return v.timestamp;
        });
        return function ($217) {
            return $216(Data_Array.head($217));
        };
    })();
    var maxTimes = map1(getMaxPerStream)(streamIntermediates);
    var minTimes = map1(getMinPerStream)(streamIntermediates);
    return bind(maximum1(Data_Array.catMaybes(maxTimes)))(function (maxTime) {
        return bind(minimum1(Data_Array.catMaybes(minTimes)))(function (minTime) {
            return pure({
                minTime: minTime,
                maxTime: maxTime
            });
        });
    });
};
var totalIntermediate = function (coalesceInterval) {
    return function (streamIntermediates) {
        return bind(getMinMax(streamIntermediates))(function (v) {
            var times = unfoldr(function (count) {
                var val = Fusion_Data_Timestamp.addDuration(v.minTime)(Fusion_Data_Duration.scale(count)(coalesceInterval));
                var $199 = greaterThan(val)(v.maxTime);
                if ($199) {
                    return Data_Maybe.Nothing.value;
                };
                return new Data_Maybe.Just(new Data_Tuple.Tuple(val, count + 1 | 0));
            })(0);
            var speedDataPointAtTimePerStream = function (ts) {
                var speeds = map1((function () {
                    var $218 = Data_Maybe.fromMaybe(mempty1);
                    var $219 = speedAtTime(coalesceInterval)(ts);
                    return function ($220) {
                        return $218($219($220));
                    };
                })())(streamIntermediates);
                return {
                    timestamp: ts,
                    speed: fold(speeds)
                };
            };
            var speedDataPoints = map1(speedDataPointAtTimePerStream)(times);
            return pure(speedDataPoints);
        });
    };
};
var binIntermediateSpeeds = function (coalesceInterval) {
    return function (responses) {
        var globalStartTime = (function (v) {
            return v.startTime;
        })(minimumBy(Data_Function.on(compare)(function (v) {
            return v.startTime;
        }))(responses));
        var getBinIndex = function (ts) {
            var dur = Fusion_Data_Timestamp.diff(ts)(globalStartTime);
            var ix = Fusion_Data_Duration.quot(dur)(coalesceInterval);
            return Data_Maybe["fromMaybe$prime"](function (v) {
                return Partial_Unsafe.unsafeCrashWith("Index too large");
            })(Data_BigInt.toInt(ix));
        };
        var result = foldl(function (accOuter) {
            return function (v) {
                return foldl(function (accInner) {
                    return function (v1) {
                        var ts = Fusion_Data_Timestamp.addDuration(v.startTime)(v1.durationSinceStart);
                        var binIndex = getBinIndex(ts);
                        return insertWith(append1)(binIndex)(v1.bytes)(accInner);
                    };
                })(accOuter)(v.loadedBytes);
            };
        })(Data_HashMap.empty)(responses);
        var finish = function (bins) {
            var maxBinIndex = maximum2(Data_HashMap.keys(bins));
            var binIndices = Data_Maybe.maybe([  ])(Data_Array.range(0))(maxBinIndex);
            return map1(function (i) {
                return {
                    timestamp: Fusion_Data_Timestamp.addDuration(globalStartTime)(Fusion_Data_Duration.scale(i)(coalesceInterval)),
                    speed: (function () {
                        var v = lookup(i)(bins);
                        if (v instanceof Data_Maybe.Just) {
                            return Fusion_Data_Speed.bytesPerDuration(v.value0)(coalesceInterval);
                        };
                        if (v instanceof Data_Maybe.Nothing) {
                            return mempty1;
                        };
                        throw new Error("Failed pattern match at Fusion.SpeedProcessing (line 253, column 22 - line 255, column 34): " + [ v.constructor.name ]);
                    })()
                };
            })(binIndices);
        };
        var $210 = lessThanOrEq(coalesceInterval)(mempty);
        if ($210) {
            return [  ];
        };
        return finish(result);
    };
};
var bestStable = function (values) {
    return maximum3(Data_Array.catMaybes(map1(stableAverage)(windows(5)(values))));
};
var calcFinal = function (inputs) {
    var maybeBestStableSpeed = map(Fusion_Data_Speed.fromBps)(bestStable(map1(Fusion_Data_Speed.toBps)(inputs.intermediateValues)));
    var averageSpeed = Fusion_Data_Speed.bytesPerDuration(inputs.transferredBytes)(inputs.transferDuration);
    var speed = (function () {
        if (maybeBestStableSpeed instanceof Data_Maybe.Just && greaterThan1(maybeBestStableSpeed.value0)(averageSpeed)) {
            return maybeBestStableSpeed.value0;
        };
        return averageSpeed;
    })();
    return {
        algorithm: "v2",
        speed: speed
    };
};
var spec = /* #__PURE__ */ describe("Fusion.SpeedProcessing")(/* #__PURE__ */ (function () {
    var ts = function ($221) {
        return Fusion_Data_Timestamp.timeIntervalSince1970(Fusion_Data_Duration.fromMs($221));
    };
    var sdp = function (t) {
        return function (s) {
            return {
                timestamp: ts(t),
                speed: Fusion_Data_Speed.fromBps(s)
            };
        };
    };
    var nea = function () {
        return function ($222) {
            return fromJust(Data_Array_NonEmpty.fromArray($222));
        };
    };
    var nea1 = nea();
    return discard1(describe("linearInterpolate")(discard1(it("works for a given timestamp t2, such that: t1 < t2 < t3")((function () {
        var actual = linearInterpolate({
            timestamp: ts(2.0),
            speed: Fusion_Data_Speed.fromBps(20.0)
        })({
            timestamp: ts(5.0),
            speed: Fusion_Data_Speed.fromBps(50.0)
        })(ts(3.0));
        var expected = Fusion_Data_Speed.fromBps(30.0);
        return shouldEqual1(actual)(expected);
    })()))(function () {
        return discard1(it("works for a given timestamp t2, such that: t2 < t1 < t3")((function () {
            var actual = linearInterpolate({
                timestamp: ts(2.0),
                speed: Fusion_Data_Speed.fromBps(2.0)
            })({
                timestamp: ts(5.0),
                speed: Fusion_Data_Speed.fromBps(5.0)
            })(ts(1.0));
            var expected = Fusion_Data_Speed.fromBps(1.0);
            return shouldEqual1(actual)(expected);
        })()))(function () {
            return discard1(it("works for a given timestamp t2, such that: t1 < t3 < t2")((function () {
                var actual = linearInterpolate({
                    timestamp: ts(2.0),
                    speed: Fusion_Data_Speed.fromBps(2.0)
                })({
                    timestamp: ts(5.0),
                    speed: Fusion_Data_Speed.fromBps(5.0)
                })(ts(6.0));
                var expected = Fusion_Data_Speed.fromBps(6.0);
                return shouldEqual1(actual)(expected);
            })()))(function () {
                return it("works for a given timestamp t2, whereas: t1 = t3")((function () {
                    var actual = linearInterpolate({
                        timestamp: ts(2.0),
                        speed: Fusion_Data_Speed.fromBps(2.0)
                    })({
                        timestamp: ts(2.0),
                        speed: Fusion_Data_Speed.fromBps(3.0)
                    })(ts(6.0));
                    var expected = Fusion_Data_Speed.fromBps(2.0);
                    return shouldEqual1(actual)(expected);
                })());
            });
        });
    })))(function () {
        return discard1(describe("getMinMax")(discard1(it("no result for no streams")((function () {
            var actual = getMinMax([  ]);
            return shouldEqual2(actual)(Data_Maybe.Nothing.value);
        })()))(function () {
            return discard1(it("no result for empty streams")((function () {
                var actual = getMinMax([ [  ], [  ] ]);
                return shouldEqual2(actual)(Data_Maybe.Nothing.value);
            })()))(function () {
                return discard1(it("min equals max if only one data point exists in streams")((function () {
                    var actual = getMinMax([ [ sdp(42.0)(13.0) ], [  ] ]);
                    return shouldEqual2(actual)(new Data_Maybe.Just({
                        minTime: ts(42.0),
                        maxTime: ts(42.0)
                    }));
                })()))(function () {
                    return discard1(it("if two different data points exsits, they get extracted as min and max (same stream)")((function () {
                        var actual = getMinMax([ [ sdp(42.0)(13.0), sdp(43.0)(14.0) ], [  ] ]);
                        return shouldEqual2(actual)(new Data_Maybe.Just({
                            minTime: ts(42.0),
                            maxTime: ts(43.0)
                        }));
                    })()))(function () {
                        return it("if two different data points exsits, they get extracted as min and max (different streams)")((function () {
                            var actual = getMinMax([ [ sdp(42.0)(13.0) ], [ sdp(43.0)(14.0) ] ]);
                            return shouldEqual2(actual)(new Data_Maybe.Just({
                                minTime: ts(42.0),
                                maxTime: ts(43.0)
                            }));
                        })());
                    });
                });
            });
        })))(function () {
            return discard1(describe("speedAtTime")(discard1(it("no result if no data points are given")((function () {
                var actual = speedAtTime(Fusion_Data_Duration.fromMs(0.0))(ts(0.0))([  ]);
                return shouldEqual3(actual)(Data_Maybe.Nothing.value);
            })()))(function () {
                return discard1(it("no result if given timestamp is ealier than first data point")((function () {
                    var actual = speedAtTime(Fusion_Data_Duration.fromMs(0.5))(ts(41.0))([ sdp(42.0)(13.0), sdp(44.0)(15.0) ]);
                    return shouldEqual3(actual)(Data_Maybe.Nothing.value);
                })()))(function () {
                    return discard1(it("no result if given timestamp is much later than last data point. (outside of the given coalesce interval)")((function () {
                        var actual = speedAtTime(Fusion_Data_Duration.fromMs(0.5))(ts(99.0))([ sdp(42.0)(13.0), sdp(44.0)(15.0) ]);
                        return shouldEqual3(actual)(Data_Maybe.Nothing.value);
                    })()))(function () {
                        return discard1(it("returns last speed if given timestamp is slightly later than last data point. (within the given coalesce interval)")((function () {
                            var actual = speedAtTime(Fusion_Data_Duration.fromMs(0.5))(ts(44.1))([ sdp(42.0)(13.0), sdp(44.0)(15.0) ]);
                            return shouldEqual3(actual)(new Data_Maybe.Just(Fusion_Data_Speed.fromBps(15.0)));
                        })()))(function () {
                            return discard1(it("interpolated result if given timestamp is between two data points")((function () {
                                var actual = speedAtTime(Fusion_Data_Duration.fromMs(0.5))(ts(43.0))([ sdp(42.0)(13.0), sdp(44.0)(15.0) ]);
                                return shouldEqual3(actual)(new Data_Maybe.Just(Fusion_Data_Speed.fromBps(14.0)));
                            })()))(function () {
                                return it("returns the matching speed if timestamp is exactly on one data point")((function () {
                                    var actual = speedAtTime(Fusion_Data_Duration.fromMs(0.5))(ts(43.0))([ sdp(42.0)(13.0), sdp(43.0)(14.0), sdp(44.0)(15.0) ]);
                                    return shouldEqual3(actual)(new Data_Maybe.Just(Fusion_Data_Speed.fromBps(14.0)));
                                })());
                            });
                        });
                    });
                });
            })))(function () {
                return discard1(describe("totalIntermediate")(discard1(it("no results if no streams are given")((function () {
                    var actual = totalIntermediate(Fusion_Data_Duration.fromMs(1.0))([  ]);
                    return shouldEqual4(actual)(Data_Maybe.Nothing.value);
                })()))(function () {
                    return discard1(it("if one stream has a constant speed and cadence of 2 and coalsece interval is 1, returned data points have same constant speed at cadence of 1.")((function () {
                        var actual = totalIntermediate(Fusion_Data_Duration.fromMs(1.0))([ [ sdp(0.0)(42.0), sdp(2.0)(42.0), sdp(4.0)(42.0), sdp(6.0)(42.0) ] ]);
                        return discard2(shouldEqual5(bind(actual)(function (v) {
                            return Data_Array.index(v)(0);
                        }))(new Data_Maybe.Just(sdp(0.0)(42.0))))(function () {
                            return discard2(shouldEqual5(bind(actual)(function (v) {
                                return Data_Array.index(v)(1);
                            }))(new Data_Maybe.Just(sdp(1.0)(42.0))))(function () {
                                return discard2(shouldEqual5(bind(actual)(function (v) {
                                    return Data_Array.index(v)(2);
                                }))(new Data_Maybe.Just(sdp(2.0)(42.0))))(function () {
                                    return discard2(shouldEqual5(bind(actual)(function (v) {
                                        return Data_Array.index(v)(3);
                                    }))(new Data_Maybe.Just(sdp(3.0)(42.0))))(function () {
                                        return discard2(shouldEqual5(bind(actual)(function (v) {
                                            return Data_Array.index(v)(4);
                                        }))(new Data_Maybe.Just(sdp(4.0)(42.0))))(function () {
                                            return discard2(shouldEqual5(bind(actual)(function (v) {
                                                return Data_Array.index(v)(5);
                                            }))(new Data_Maybe.Just(sdp(5.0)(42.0))))(function () {
                                                return discard2(shouldEqual5(bind(actual)(function (v) {
                                                    return Data_Array.index(v)(6);
                                                }))(new Data_Maybe.Just(sdp(6.0)(42.0))))(function () {
                                                    return shouldEqual6(mapFlipped(actual)(length1))(new Data_Maybe.Just(7));
                                                });
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    })()))(function () {
                        return discard1(it("if many constant streams are given of different cadences (2 and 3) and coalesce interval is 1, returned data points have constant summarized speed at cadence of 1.")((function () {
                            var actual = totalIntermediate(Fusion_Data_Duration.fromMs(1.0))([ [ sdp(0.0)(42.0), sdp(2.0)(42.0), sdp(4.0)(42.0), sdp(6.0)(42.0) ], [ sdp(0.0)(42.0), sdp(3.0)(42.0), sdp(6.0)(42.0) ] ]);
                            return discard2(shouldEqual5(bind(actual)(function (v) {
                                return Data_Array.index(v)(0);
                            }))(new Data_Maybe.Just(sdp(0.0)(84.0))))(function () {
                                return discard2(shouldEqual5(bind(actual)(function (v) {
                                    return Data_Array.index(v)(1);
                                }))(new Data_Maybe.Just(sdp(1.0)(84.0))))(function () {
                                    return discard2(shouldEqual5(bind(actual)(function (v) {
                                        return Data_Array.index(v)(2);
                                    }))(new Data_Maybe.Just(sdp(2.0)(84.0))))(function () {
                                        return discard2(shouldEqual5(bind(actual)(function (v) {
                                            return Data_Array.index(v)(3);
                                        }))(new Data_Maybe.Just(sdp(3.0)(84.0))))(function () {
                                            return discard2(shouldEqual5(bind(actual)(function (v) {
                                                return Data_Array.index(v)(4);
                                            }))(new Data_Maybe.Just(sdp(4.0)(84.0))))(function () {
                                                return discard2(shouldEqual5(bind(actual)(function (v) {
                                                    return Data_Array.index(v)(5);
                                                }))(new Data_Maybe.Just(sdp(5.0)(84.0))))(function () {
                                                    return discard2(shouldEqual5(bind(actual)(function (v) {
                                                        return Data_Array.index(v)(6);
                                                    }))(new Data_Maybe.Just(sdp(6.0)(84.0))))(function () {
                                                        return shouldEqual6(mapFlipped(actual)(length1))(new Data_Maybe.Just(7));
                                                    });
                                                });
                                            });
                                        });
                                    });
                                });
                            });
                        })()))(function () {
                            return it("if many linearly increasing speeds of different cadences (2 and 3) are given and coalesce interval is 1, returned data points have linear increasing summarized speed at cadence of 1.")((function () {
                                var actual = totalIntermediate(Fusion_Data_Duration.fromMs(1.0))([ [ sdp(0.0)(0.0), sdp(2.0)(20.0), sdp(4.0)(40.0), sdp(6.0)(60.0) ], [ sdp(0.0)(0.0), sdp(3.0)(30.0), sdp(6.0)(60.0) ] ]);
                                return discard2(shouldEqual5(bind(actual)(function (v) {
                                    return Data_Array.index(v)(0);
                                }))(new Data_Maybe.Just(sdp(0.0)(0.0))))(function () {
                                    return discard2(shouldEqual5(bind(actual)(function (v) {
                                        return Data_Array.index(v)(1);
                                    }))(new Data_Maybe.Just(sdp(1.0)(20.0))))(function () {
                                        return discard2(shouldEqual5(bind(actual)(function (v) {
                                            return Data_Array.index(v)(2);
                                        }))(new Data_Maybe.Just(sdp(2.0)(40.0))))(function () {
                                            return discard2(shouldEqual5(bind(actual)(function (v) {
                                                return Data_Array.index(v)(3);
                                            }))(new Data_Maybe.Just(sdp(3.0)(60.0))))(function () {
                                                return discard2(shouldEqual5(bind(actual)(function (v) {
                                                    return Data_Array.index(v)(4);
                                                }))(new Data_Maybe.Just(sdp(4.0)(80.0))))(function () {
                                                    return discard2(shouldEqual5(bind(actual)(function (v) {
                                                        return Data_Array.index(v)(5);
                                                    }))(new Data_Maybe.Just(sdp(5.0)(100.0))))(function () {
                                                        return discard2(shouldEqual5(bind(actual)(function (v) {
                                                            return Data_Array.index(v)(6);
                                                        }))(new Data_Maybe.Just(sdp(6.0)(120.0))))(function () {
                                                            return shouldEqual6(mapFlipped(actual)(length1))(new Data_Maybe.Just(7));
                                                        });
                                                    });
                                                });
                                            });
                                        });
                                    });
                                });
                            })());
                        });
                    });
                })))(function () {
                    return discard1(describe("windows")(discard1(it("works for empty input")((function () {
                        var actual = windows(3)([  ]);
                        return shouldEqual7(actual)([  ]);
                    })()))(function () {
                        return it("returns only windoes of the given size")((function () {
                            var actual = windows(3)([ 1, 2, 3, 4, 5 ]);
                            return shouldEqual7(actual)([ nea1([ 1, 2, 3 ]), nea1([ 2, 3, 4 ]), nea1([ 3, 4, 5 ]) ]);
                        })());
                    })))(function () {
                        return discard1(describe("stableAverage")(discard1(it("returns nothing if input contains a zero")((function () {
                            var actual = stableAverage(nea1([ 1.3, 9.0, 0.0, 6.9 ]));
                            return shouldEqual8(actual)(Data_Maybe.Nothing.value);
                        })()))(function () {
                            return discard1(it("returns nothing if min and max value in input are not close enough")((function () {
                                var actual = stableAverage(nea1([ 10.0, 20.0, 30.0 ]));
                                return shouldEqual8(actual)(Data_Maybe.Nothing.value);
                            })()))(function () {
                                return discard1(it("returns the average if min and max value in the input array are sufficiently close")((function () {
                                    var actual = stableAverage(nea1([ 9.5, 10.1, 10.4 ]));
                                    return shouldEqual8(actual)(new Data_Maybe.Just(10.0));
                                })()))(function () {
                                    return it("works for window of size 1")((function () {
                                        var actual = stableAverage(nea1([ 10.0 ]));
                                        return shouldEqual8(actual)(new Data_Maybe.Just(10.0));
                                    })());
                                });
                            });
                        })))(function () {
                            return discard1(describe("bestStable")(discard1(it("return nothing for empty inputs")((function () {
                                var actual = bestStable([  ]);
                                return shouldEqual8(actual)(Data_Maybe.Nothing.value);
                            })()))(function () {
                                return it("selects the best stable window and takes its average")((function () {
                                    var actual = bestStable(append2([ 5.0, 15.0 ])(append2([ 5.0, 5.0, 5.0, 5.0, 5.0 ])([ 15.0, 5.0, 15.0, 5.0, 15.0 ])));
                                    return shouldEqual8(actual)(new Data_Maybe.Just(5.0));
                                })());
                            })))(function () {
                                return discard1(describe("calcFinal")(discard1(it("works without intermediates")((function () {
                                    var actual = calcFinal({
                                        transferDuration: Fusion_Data_Duration.fromMs(10000.0),
                                        transferredBytes: Fusion_Data_Bytes.fromInt(1000000),
                                        intermediateValues: [  ]
                                    });
                                    return shouldEqual1(actual.speed)(Fusion_Data_Speed.fromBps(800000.0));
                                })()))(function () {
                                    return discard1(it("works with zeros")((function () {
                                        var actual = calcFinal({
                                            transferDuration: Fusion_Data_Duration.fromMs(10000.0),
                                            transferredBytes: Fusion_Data_Bytes.fromInt(500000),
                                            intermediateValues: [ Fusion_Data_Speed.fromBps(800000.0), Fusion_Data_Speed.fromBps(800000.0), Fusion_Data_Speed.fromBps(0.0), Fusion_Data_Speed.fromBps(800000.0), Fusion_Data_Speed.fromBps(800000.0), Fusion_Data_Speed.fromBps(800000.0) ]
                                        });
                                        return shouldEqual1(actual.speed)(Fusion_Data_Speed.fromBps(400000.0));
                                    })()))(function () {
                                        return discard1(it("works with stable window")((function () {
                                            var actual = calcFinal({
                                                transferDuration: Fusion_Data_Duration.fromMs(10000.0),
                                                transferredBytes: Fusion_Data_Bytes.fromInt(500000),
                                                intermediateValues: [ Fusion_Data_Speed.fromBps(800000.0), Fusion_Data_Speed.fromBps(800000.0), Fusion_Data_Speed.fromBps(800000.0), Fusion_Data_Speed.fromBps(800000.0), Fusion_Data_Speed.fromBps(800000.0), Fusion_Data_Speed.fromBps(800000.0) ]
                                            });
                                            return shouldEqual1(actual.speed)(Fusion_Data_Speed.fromBps(800000.0));
                                        })()))(function () {
                                            return it("slow start is ignored")((function () {
                                                var actual = calcFinal({
                                                    transferDuration: Fusion_Data_Duration.fromMs(10000.0),
                                                    transferredBytes: Fusion_Data_Bytes.fromInt(500000),
                                                    intermediateValues: [ Fusion_Data_Speed.fromBps(100000.0), Fusion_Data_Speed.fromBps(200000.0), Fusion_Data_Speed.fromBps(300000.0), Fusion_Data_Speed.fromBps(400000.0), Fusion_Data_Speed.fromBps(500000.0), Fusion_Data_Speed.fromBps(600000.0), Fusion_Data_Speed.fromBps(700000.0), Fusion_Data_Speed.fromBps(800000.0), Fusion_Data_Speed.fromBps(800000.0), Fusion_Data_Speed.fromBps(800000.0), Fusion_Data_Speed.fromBps(800000.0), Fusion_Data_Speed.fromBps(800000.0), Fusion_Data_Speed.fromBps(800000.0), Fusion_Data_Speed.fromBps(800000.0) ]
                                                });
                                                return shouldEqual1(actual.speed)(Fusion_Data_Speed.fromBps(800000.0));
                                            })());
                                        });
                                    });
                                })))(function () {
                                    return describe("binIntermediateSpeeds")(discard1(it("works for two bins, no stream overlaps a bin")((function () {
                                        var actual = binIntermediateSpeeds(Fusion_Data_Duration.fromMs(1000.0))(fromJust(Data_Array_NonEmpty.fromArray([ {
                                            loadedBytes: fromJust(Data_Array_NonEmpty.fromArray([ {
                                                durationSinceStart: Fusion_Data_Duration.fromMs(200.0),
                                                bytes: Fusion_Data_Bytes.fromInt(10)
                                            }, {
                                                durationSinceStart: Fusion_Data_Duration.fromMs(400.0),
                                                bytes: Fusion_Data_Bytes.fromInt(20)
                                            }, {
                                                durationSinceStart: Fusion_Data_Duration.fromMs(600.0),
                                                bytes: Fusion_Data_Bytes.fromInt(30)
                                            } ])),
                                            startTime: Fusion_Data_Timestamp.timeIntervalSince1970(Fusion_Data_Duration.fromMs(0.0))
                                        }, {
                                            loadedBytes: fromJust(Data_Array_NonEmpty.fromArray([ {
                                                durationSinceStart: Fusion_Data_Duration.fromMs(200.0),
                                                bytes: Fusion_Data_Bytes.fromInt(100)
                                            }, {
                                                durationSinceStart: Fusion_Data_Duration.fromMs(400.0),
                                                bytes: Fusion_Data_Bytes.fromInt(200)
                                            }, {
                                                durationSinceStart: Fusion_Data_Duration.fromMs(600.0),
                                                bytes: Fusion_Data_Bytes.fromInt(300)
                                            } ])),
                                            startTime: Fusion_Data_Timestamp.timeIntervalSince1970(Fusion_Data_Duration.fromMs(1000.0))
                                        } ])));
                                        var expected = [ {
                                            speed: Fusion_Data_Speed.bytesPerDuration(Fusion_Data_Bytes.fromInt(60))(Fusion_Data_Duration.fromMs(1000.0)),
                                            timestamp: Fusion_Data_Timestamp.timeIntervalSince1970(Fusion_Data_Duration.fromMs(0.0))
                                        }, {
                                            speed: Fusion_Data_Speed.bytesPerDuration(Fusion_Data_Bytes.fromInt(600))(Fusion_Data_Duration.fromMs(1000.0)),
                                            timestamp: Fusion_Data_Timestamp.timeIntervalSince1970(Fusion_Data_Duration.fromMs(1000.0))
                                        } ];
                                        return shouldEqual9(actual)(expected);
                                    })()))(function () {
                                        return discard1(it("works for two bins, stream overlapping")((function () {
                                            var actual = binIntermediateSpeeds(Fusion_Data_Duration.fromMs(1000.0))(fromJust(Data_Array_NonEmpty.fromArray([ {
                                                loadedBytes: fromJust(Data_Array_NonEmpty.fromArray([ {
                                                    durationSinceStart: Fusion_Data_Duration.fromMs(800.0),
                                                    bytes: Fusion_Data_Bytes.fromInt(10)
                                                }, {
                                                    durationSinceStart: Fusion_Data_Duration.fromMs(900.0),
                                                    bytes: Fusion_Data_Bytes.fromInt(20)
                                                }, {
                                                    durationSinceStart: Fusion_Data_Duration.fromMs(1000.0),
                                                    bytes: Fusion_Data_Bytes.fromInt(30)
                                                }, {
                                                    durationSinceStart: Fusion_Data_Duration.fromMs(1100.0),
                                                    bytes: Fusion_Data_Bytes.fromInt(40)
                                                } ])),
                                                startTime: Fusion_Data_Timestamp.timeIntervalSince1970(Fusion_Data_Duration.fromMs(0.0))
                                            } ])));
                                            var expected = [ {
                                                speed: Fusion_Data_Speed.bytesPerDuration(Fusion_Data_Bytes.fromInt(30))(Fusion_Data_Duration.fromMs(1000.0)),
                                                timestamp: Fusion_Data_Timestamp.timeIntervalSince1970(Fusion_Data_Duration.fromMs(0.0))
                                            }, {
                                                speed: Fusion_Data_Speed.bytesPerDuration(Fusion_Data_Bytes.fromInt(70))(Fusion_Data_Duration.fromMs(1000.0)),
                                                timestamp: Fusion_Data_Timestamp.timeIntervalSince1970(Fusion_Data_Duration.fromMs(1000.0))
                                            } ];
                                            return shouldEqual9(actual)(expected);
                                        })()))(function () {
                                            return discard1(it("works for one bin and two streams overlapping eachother")((function () {
                                                var actual = binIntermediateSpeeds(Fusion_Data_Duration.fromMs(1000.0))(fromJust(Data_Array_NonEmpty.fromArray([ {
                                                    loadedBytes: fromJust(Data_Array_NonEmpty.fromArray([ {
                                                        durationSinceStart: Fusion_Data_Duration.fromMs(100.0),
                                                        bytes: Fusion_Data_Bytes.fromInt(10)
                                                    }, {
                                                        durationSinceStart: Fusion_Data_Duration.fromMs(200.0),
                                                        bytes: Fusion_Data_Bytes.fromInt(20)
                                                    }, {
                                                        durationSinceStart: Fusion_Data_Duration.fromMs(300.0),
                                                        bytes: Fusion_Data_Bytes.fromInt(30)
                                                    }, {
                                                        durationSinceStart: Fusion_Data_Duration.fromMs(400.0),
                                                        bytes: Fusion_Data_Bytes.fromInt(40)
                                                    } ])),
                                                    startTime: Fusion_Data_Timestamp.timeIntervalSince1970(Fusion_Data_Duration.fromMs(0.0))
                                                }, {
                                                    loadedBytes: fromJust(Data_Array_NonEmpty.fromArray([ {
                                                        durationSinceStart: Fusion_Data_Duration.fromMs(100.0),
                                                        bytes: Fusion_Data_Bytes.fromInt(10)
                                                    }, {
                                                        durationSinceStart: Fusion_Data_Duration.fromMs(200.0),
                                                        bytes: Fusion_Data_Bytes.fromInt(20)
                                                    }, {
                                                        durationSinceStart: Fusion_Data_Duration.fromMs(300.0),
                                                        bytes: Fusion_Data_Bytes.fromInt(30)
                                                    }, {
                                                        durationSinceStart: Fusion_Data_Duration.fromMs(400.0),
                                                        bytes: Fusion_Data_Bytes.fromInt(40)
                                                    } ])),
                                                    startTime: Fusion_Data_Timestamp.timeIntervalSince1970(Fusion_Data_Duration.fromMs(750.0))
                                                } ])));
                                                var expected = [ {
                                                    speed: Fusion_Data_Speed.bytesPerDuration(Fusion_Data_Bytes.fromInt(130))(Fusion_Data_Duration.fromMs(1000.0)),
                                                    timestamp: Fusion_Data_Timestamp.timeIntervalSince1970(Fusion_Data_Duration.fromMs(0.0))
                                                }, {
                                                    speed: Fusion_Data_Speed.bytesPerDuration(Fusion_Data_Bytes.fromInt(70))(Fusion_Data_Duration.fromMs(1000.0)),
                                                    timestamp: Fusion_Data_Timestamp.timeIntervalSince1970(Fusion_Data_Duration.fromMs(1000.0))
                                                } ];
                                                return shouldEqual9(actual)(expected);
                                            })()))(function () {
                                                return discard1(it("works for two streams which partly overlap and span over three bins")((function () {
                                                    var actual = binIntermediateSpeeds(Fusion_Data_Duration.fromMs(1000.0))(fromJust(Data_Array_NonEmpty.fromArray([ {
                                                        loadedBytes: fromJust(Data_Array_NonEmpty.fromArray([ {
                                                            durationSinceStart: Fusion_Data_Duration.fromMs(100.0),
                                                            bytes: Fusion_Data_Bytes.fromInt(10)
                                                        }, {
                                                            durationSinceStart: Fusion_Data_Duration.fromMs(500.0),
                                                            bytes: Fusion_Data_Bytes.fromInt(10)
                                                        }, {
                                                            durationSinceStart: Fusion_Data_Duration.fromMs(900.0),
                                                            bytes: Fusion_Data_Bytes.fromInt(10)
                                                        }, {
                                                            durationSinceStart: Fusion_Data_Duration.fromMs(1100.0),
                                                            bytes: Fusion_Data_Bytes.fromInt(10)
                                                        }, {
                                                            durationSinceStart: Fusion_Data_Duration.fromMs(1500.0),
                                                            bytes: Fusion_Data_Bytes.fromInt(10)
                                                        }, {
                                                            durationSinceStart: Fusion_Data_Duration.fromMs(1900.0),
                                                            bytes: Fusion_Data_Bytes.fromInt(10)
                                                        }, {
                                                            durationSinceStart: Fusion_Data_Duration.fromMs(2100.0),
                                                            bytes: Fusion_Data_Bytes.fromInt(10)
                                                        }, {
                                                            durationSinceStart: Fusion_Data_Duration.fromMs(2500.0),
                                                            bytes: Fusion_Data_Bytes.fromInt(10)
                                                        }, {
                                                            durationSinceStart: Fusion_Data_Duration.fromMs(2900.0),
                                                            bytes: Fusion_Data_Bytes.fromInt(10)
                                                        } ])),
                                                        startTime: Fusion_Data_Timestamp.timeIntervalSince1970(Fusion_Data_Duration.fromMs(0.0))
                                                    }, {
                                                        loadedBytes: fromJust(Data_Array_NonEmpty.fromArray([ {
                                                            durationSinceStart: Fusion_Data_Duration.fromMs(100.0),
                                                            bytes: Fusion_Data_Bytes.fromInt(10)
                                                        }, {
                                                            durationSinceStart: Fusion_Data_Duration.fromMs(500.0),
                                                            bytes: Fusion_Data_Bytes.fromInt(10)
                                                        }, {
                                                            durationSinceStart: Fusion_Data_Duration.fromMs(900.0),
                                                            bytes: Fusion_Data_Bytes.fromInt(10)
                                                        }, {
                                                            durationSinceStart: Fusion_Data_Duration.fromMs(1100.0),
                                                            bytes: Fusion_Data_Bytes.fromInt(10)
                                                        }, {
                                                            durationSinceStart: Fusion_Data_Duration.fromMs(1500.0),
                                                            bytes: Fusion_Data_Bytes.fromInt(10)
                                                        }, {
                                                            durationSinceStart: Fusion_Data_Duration.fromMs(1900.0),
                                                            bytes: Fusion_Data_Bytes.fromInt(10)
                                                        } ])),
                                                        startTime: Fusion_Data_Timestamp.timeIntervalSince1970(Fusion_Data_Duration.fromMs(1000.0))
                                                    } ])));
                                                    var expected = [ {
                                                        speed: Fusion_Data_Speed.bytesPerDuration(Fusion_Data_Bytes.fromInt(30))(Fusion_Data_Duration.fromMs(1000.0)),
                                                        timestamp: Fusion_Data_Timestamp.timeIntervalSince1970(Fusion_Data_Duration.fromMs(0.0))
                                                    }, {
                                                        speed: Fusion_Data_Speed.bytesPerDuration(Fusion_Data_Bytes.fromInt(60))(Fusion_Data_Duration.fromMs(1000.0)),
                                                        timestamp: Fusion_Data_Timestamp.timeIntervalSince1970(Fusion_Data_Duration.fromMs(1000.0))
                                                    }, {
                                                        speed: Fusion_Data_Speed.bytesPerDuration(Fusion_Data_Bytes.fromInt(60))(Fusion_Data_Duration.fromMs(1000.0)),
                                                        timestamp: Fusion_Data_Timestamp.timeIntervalSince1970(Fusion_Data_Duration.fromMs(2000.0))
                                                    } ];
                                                    return shouldEqual9(actual)(expected);
                                                })()))(function () {
                                                    return it("is stack safe")((function () {
                                                        var input = fromJust(Data_Array_NonEmpty.fromArray(Data_Array.replicate(100)({
                                                            loadedBytes: fromJust(Data_Array_NonEmpty.fromArray(Data_Array.replicate(10000)({
                                                                durationSinceStart: Fusion_Data_Duration.fromMs(200.0),
                                                                bytes: Fusion_Data_Bytes.fromInt(10)
                                                            }))),
                                                            startTime: Fusion_Data_Timestamp.timeIntervalSince1970(Fusion_Data_Duration.fromMs(0.0))
                                                        })));
                                                        return bind1(Fusion_Impl_AppM.runAppM(measureTime1("TIME: binIntermediateSpeeds 100 * 10_000")(function (v) {
                                                            return pure1(binIntermediateSpeeds(Fusion_Data_Duration.fromMs(1000.0))(input));
                                                        })))(function (v) {
                                                            return pure2(Data_Unit.unit);
                                                        });
                                                    })());
                                                });
                                            });
                                        });
                                    }));
                                });
                            });
                        });
                    });
                });
            });
        });
    });
})());
export {
    binIntermediateSpeeds,
    calcFinal,
    spec,
    totalIntermediate
};
//# sourceMappingURL=index.js.map
